import { getLandingUrlFromPath } from '@doltech/utils/lib/url';
import cl from 'classnames';
import * as React from 'react';
import { SpaceProps, TextColorProps } from 'styled-system';
import { TitleProps as AntTitleProps } from 'antd/lib/typography/Title';

import { DOLThemeType } from '../../../Common/theme';
import {
  DOLTypographyVariant,
  TitleProps as TypoTitleProps,
  Typography,
} from '../../../DesignSystemV2/Typography';
import { Link } from '../../../Link';

const DEFAULT_TYPO = 'semi-bold/16';

export interface TitleProps extends TextColorProps<DOLThemeType>, SpaceProps {
  className?: string;
  url?: string;
  text?: React.ReactNode;
  typoVariant?: DOLTypographyVariant;
  typoVariantTablet?: DOLTypographyVariant;
  typoVariantDesktop?: DOLTypographyVariant;
  ellipsis?: TypoTitleProps['ellipsis'];
  headingLevel?: AntTitleProps['level'] | boolean;
  prefetch?: boolean;
}

const withLink = (Component: React.ComponentType<TitleProps>) => (props: TitleProps) => {
  const { className, url, prefetch = false, ...rest } = props;
  if (url) {
    return (
      <Link prefetch={prefetch} className={cl('link', className)} href={getLandingUrlFromPath(url)}>
        <Component {...rest} />
      </Link>
    );
  }
  return <Component {...props} />;
};

const TitleOrParagraph = (props: TitleProps) => {
  const {
    className,
    url,
    text,
    typoVariant = DEFAULT_TYPO,
    typoVariantTablet = typoVariant,
    typoVariantDesktop = typoVariantTablet,
    color = 'black100',
    ellipsis = { rows: 2 },
    headingLevel = 3,
    ...rest
  } = props;

  if (headingLevel) {
    return (
      <Typography.Title
        className={className}
        level={headingLevel as AntTitleProps['level']}
        variant={typoVariant}
        tabletVariant={typoVariantTablet}
        desktopVariant={typoVariantDesktop}
        ellipsis={ellipsis}
        color={color}
        {...rest}
      >
        {text}
      </Typography.Title>
    );
  }
  return (
    <Typography.Paragraph
      className={className}
      variant={typoVariant}
      tabletVariant={typoVariantTablet}
      desktopVariant={typoVariantDesktop}
      ellipsis={ellipsis}
      color={color}
      {...rest}
    >
      {text}
    </Typography.Paragraph>
  );
};

export const Title = withLink(TitleOrParagraph);
